import { useEffect } from 'react';

/**
 * useScrollReveal
 * Attaches an IntersectionObserver to all elements with `.reveal-on-scroll`
 * and applies `.is-revealed` when they enter the viewport.
 */
export function useScrollReveal() {
  useEffect(() => {
    const targets = document.querySelectorAll('.reveal-on-scroll');
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            // Optional: unobserve once revealed for performance
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px',
      }
    );

    targets.forEach((el) => observer.observe(el));

    return () => {
      targets.forEach((el) => observer.unobserve(el));
    };
  }, []);
}
